import {
  DefaultRtbCampaignBasicFormModel,
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
export interface DisplayFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}
abstract class AbstractDisplayFormModel
  extends DefaultRtbCampaignBasicFormModel
  implements DisplayFormModel
{
  get campaignAdType(): AdType {
    return AdType.DISPLAY;
  }
}

export class EditDisplayFormModel extends AbstractDisplayFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return false;
  }
  get canEditPriceModel(): boolean {
    return false;
  }

  canEditOptimize(): boolean {
    return false;
  }
}

export class CreateDisplayFormModel extends AbstractDisplayFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('create', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return true;
  }
  get canEditPriceModel(): boolean {
    return true;
  }
}
